import type { SmartFillBucketVisibility } from '@oysterjs/smartfill-contracts';

/** The PRIVATE/PUBLIC visibility picker with one shared pair of labels. */
export function VisibilitySelect({
  id,
  ariaLabel,
  value,
  disabled,
  onChange
}: {
  id?: string;
  ariaLabel?: string;
  value: SmartFillBucketVisibility;
  disabled?: boolean;
  onChange: (visibility: SmartFillBucketVisibility) => void;
}) {
  return (
    <select
      id={id}
      aria-label={ariaLabel}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value === 'PUBLIC' ? 'PUBLIC' : 'PRIVATE')}
    >
      <option value="PRIVATE">Only me</option>
      <option value="PUBLIC">My agency</option>
    </select>
  );
}
